//! @ngInject
export function noteSubjectSetupModalCtrl($scope, $rootScope, $uibModalInstance, fields, data, DatabaseApi, toaster, FormService, noteService) {
    $scope.fields = FormService.getFields(fields, data);

    $scope.form = {};

    $scope.fieldChanged = (item) => {
        if (item.type.type === "Boolean" && data.id) {
            $scope.submitForm();
        }
    }

    $scope.submitForm = () => {
        if ($scope.form.data.$invalid) return;

        const body = FormService.prepareFormData($scope.fields);

        if (data.id) {
            delete body.text;
            noteService.editAgencyNoteSubject($rootScope.agencyId, $rootScope.agencyMemberId, data.id, body).then(res => {
                toaster.pop('success', "Collection status saved");
                $scope.closeModal();
            }, (err) => {
                toaster.pop('error', "Something went wrong", "Could not edit note subject")
            });
        } else {
            noteService.createAgencyNoteSubject($rootScope.agencyId, $rootScope.agencyMemberId, body).then(res => {
                toaster.pop('success', "Collection status saved");
                $scope.closeModal();
            }, (err) => {
                toaster.pop('error', "Something went wrong", "Could not create note subject")
            });
        }
    };

    $scope.closeModal = () => {
        $uibModalInstance.close('ok');
    };

    $scope.exit = () => {
        $uibModalInstance.dismiss();
    };

};
